export const GET_LOGO_IMG_LINKS = 'header/GET_LOGO_IMG_LINKS';
export const GET_LOGO_IMG_STATICS = 'header/GET_LOGO_IMG_STATICS';
